import { mapGaugesProperties } from 'app/utils/entities/match_data';
import { roundForDisplay } from 'app/utils/number';

const getMapStats = (
  videogame: VideogameSlug,
  opponent1: MapWinrateOpponent | undefined,
  opponent2: MapWinrateOpponent | undefined
): GaugeStatLine<MapWinrateOpponent>[] => {
  if (opponent1 || opponent2) {
    switch (videogame) {
      case 'cs-go': {
        const opponent1Data = opponent1!;
        const opponent2Data = opponent2!;

        // Sort properties in this array by wanted display order
        const properties: GaugeStatProperties<MapWinrateOpponentCs>[] = [
          { name: 'pistol_winrate', highlighted: 'max' },
          { name: 'ct_winrate', variation: 'cs_ct', highlighted: 'max' },
          { name: 't_winrate', variation: 'cs_t', highlighted: 'max' },
          {
            name: 'rounds_per_map',
            variation: 'cs_t',
            absoluteValue: true,
            displayFunction: roundForDisplay(1)
          }
        ];

        return mapGaugesProperties(properties, opponent1Data, opponent2Data);
      }
      default:
        return [];
    }
  }

  return [];
};

export { getMapStats };
